export default __webpack_public_path__ + "static/media/1.e23c5159.jpg";